import { createSelector } from '@reduxjs/toolkit';

const messageState = (state) => state.message;

// Retrieve the Map state specific objects
export const selectAlertMessage = createSelector(messageState, (message) => message.alert);
